/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Allstatuses1Inputs */

const en_common_allstatuses1 = /** @type {(inputs: Common_Allstatuses1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Status`)
};

/**
* | output |
* | --- |
* | "All Status" |
*
* @param {Common_Allstatuses1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_allstatuses1 = /** @type {((inputs?: Common_Allstatuses1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Allstatuses1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_allstatuses1(inputs)
});
export { common_allstatuses1 as "common_allStatuses" }